import Vue from 'vue'
import App from './App.vue'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import VueLazyBackgroundImage from 'vue-lazy-background-images/VueLazyBackgroundImage'
import router from './router'
import vueSmoothScroll from 'vue2-smooth-scroll'
//import VueMeta from 'vue-meta';
import axios from 'axios';
import VueAxios from 'vue-axios'
import 'leaflet/dist/leaflet.css';

// import Multiselect from 'vue-multiselect'
//import vueScrollBehavior from 'vue-scroll-behavior'
//Vue.use(vueScrollBehavior, { router: router })

Vue.config.productionTip = false
/*
Vue.use(VueMeta,
{
  refreshOnceOnNavigation: true
});
*/

Vue.use(VueAxios, axios);
Vue.use(VueLodash, { name: 'custom' , lodash: lodash })
Vue.component('lazy-background', VueLazyBackgroundImage)
Vue.use(vueSmoothScroll)
// Vue.component('multiselect', Multiselect)

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
